export default __webpack_public_path__ + "static/media/USDC.a27f8768.svg";